<template>
  <div id="need-land">
    <tz-map
      ref="tzMap"
      :position="position"
      container="mapView"
      :zoom="7"
      mw="100%"
      mh="800px"
      :maxZoom="18"
    >
      <tz-toggle-map :base-list="configList" :is-note="true" :index="0" />
    </tz-map>
    <!-- 图层 -->
    <div class="layer">
      <layer :map-view="mapView" @callBackCheckNode="callBackCheckNode"></layer>
    </div>
    <!-- 图层 -->

    <!-- 工具 -->
    <div class="tool">
      <tools :map-view="mapView"></tools>
    </div>
    <!-- 工具 -->

    <!-- 行政区划 -->

    <div class="administrative-region">
      <el-cascader
        ref="regionValue"
        v-model="regionValue"
        :options="xzqhList"
        :props="{ checkStrictly: true }"
        clearable
        placeholder="行政区划选择"
        @change="changeRegion"
        style="width: 100%"
        popper-class="theder"
      ></el-cascader>
    </div>
    <!-- 行政区划 -->

    <!-- 发布需求 -->
    <div class="land-need-box">
      <span class="land-need-box-span1">未找到地块？</span>
      <span class="land-need-box-span2" @click="releaseNeed">发布需求！</span>
    </div>
    <!-- 发布需求 -->
    <!-- 查询 -->
    <div class="search-box">
      <div class="search-box-input">
        <el-input
          v-model="searchValue"
          @change="searchFrom"
          @clear="clearFrom"
          style="width: 100%"
          :clearable="true"
          placeholder="请输入内容"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchFrom"
          ></el-button>
        </el-input>
      </div>
      <div class="search-box-list">
        <div class="search-box-list-top" v-show="searchValue || countyValue">
          <div
            class="search-box-list-top-li"
            :class="type == 1 ? 'active-li' : 'dft-li'"
            @click="type = 1"
          >
            开发区
          </div>
          <div
            class="search-box-list-top-li"
            :class="type == 2 ? 'active-li' : 'dft-li'"
            @click="type = 2"
          >
            地块
          </div>
        </div>

        <div
          class="search-box-list-table scrollbar-definition"
          v-if="(packList.length && type == 1) || type == 2 || loading"
          ref="table"
          v-loading="loading"
        >
          <div class="table-park">
            <park-card-box
              v-show="type == 1"
              v-for="(item, index) in packList"
              :key="index"
              :detailInfo="item"
              :isAtive="item.isAtive"
              :nowIndex="index"
              @onDetail="detailBtnPark"
            ></park-card-box>
          </div>
          <div class="table-land">
            <div
              v-if="type == 2 && (searchValue || countyValue) && !loading"
              class="landQueryCondition"
            >
              <el-form label-suffix=":">
                <el-form-item label="土地用途">
                  <el-select v-model="landSearch.type">
                    <el-option
                      v-for="(item, index) in tdytList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所需面积">
                  <div class="need-area">
                    <el-slider
                      class="need-area-slider"
                      v-model="area"
                      :range="true"
                      @change="areaSliderChange"
                    ></el-slider>
                    <el-input
                      v-model="landSearch.areaMix"
                      class="need-area-input"
                    ></el-input>
                    -
                    <el-input
                      v-model="landSearch.areaMax"
                      class="need-area-input"
                    ></el-input>
                    <span>亩</span>
                  </div>
                  <!-- <el-input-number
                    v-model="landSearch.areaMin"
                    :min="0"
                    class="land-area-number"
                  />
                  -
                  <el-input-number
                    v-model="landSearch.areaMax"
                    :min="0"
                    class="land-area-number"
                  />
                  公顷 -->
                </el-form-item>
                <el-form-item class="queryButtonItem">
                  <el-button
                    type="primary"
                    size="mini"
                    class="queryButton"
                    @click="landQuery"
                    >确定
                  </el-button>
                  <el-button
                    size="mini"
                    class="queryButton"
                    @click="resetLandQuery"
                    >重置
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="land-list">
              <land-card-box
                v-show="type == 2"
                v-for="(item, index) in landList"
                :key="index"
                :detailInfo="item"
                :isAtive="item.isAtive"
                :nowIndex="index"
                @onDetail="detailBtnLand"
              ></land-card-box>
            </div>
            <div
              class="search-box-box"
              v-if="
                type == 2 && !landList.length && (searchValue || countyValue)
              "
            >
              <div class="search-box-box-top">
                <img src="../../assets/images/common/3.png" alt="" />
              </div>
              <div class="search-box-box-center">
                <p>抱歉，没有找到符合条件的地块</p>
                <p>你可以去：</p>
              </div>
              <div class="search-box-box-btn" @click="releaseNeed">
                发布需求
              </div>
            </div>
          </div>
        </div>
        <div
          class="search-box-list-page"
          v-if="
            (type == 1 && packList.length) || (type == 2 && landList.length)
          "
        >
          <el-pagination
            :pager-count="5"
            :current-page="form.current"
            :page-sizes="[10, 20, 40, 80]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="form.size"
            layout=" prev, pager, next,total "
            :total="form.total"
          ></el-pagination>
        </div>

        <div
          class="search-box-box"
          v-if="
            type == 1 &&
            !packList.length &&
            (searchValue || countyValue) &&
            !loading
          "
        >
          <div class="search-box-box-top">
            <img src="../../assets/images/common/3.png" alt="" />
          </div>
          <div class="search-box-box-center">
            <p>抱歉，没有找到符合条件的园区</p>
            <p>你可以去：</p>
          </div>
          <div class="search-box-box-btn" @click="releaseNeed">发布需求</div>
        </div>
      </div>
    </div>

    <!-- 查询 -->
    <!--快捷查询-->
    <div class="shortcut-query">
      <el-button
        :type="typeStatus == '5' ? 'success' : ''"
        @click="shortcutQuery('5')"
        >商业用地</el-button
      >
      <el-button
        :type="typeStatus == '7' ? 'success' : ''"
        @click="shortcutQuery('7')"
        >住宅用地</el-button
      >
      <el-button
        :type="typeStatus == '6' ? 'success' : ''"
        @click="shortcutQuery('6')"
        >工矿仓储用地</el-button
      >
      <el-button
        :type="typeStatus == '12' ? 'success' : ''"
        @click="shortcutQuery('12')"
        >其他用地</el-button
      >
    </div>

    <!-- 园区详情 -->
    <transition name="el-zoom-in-center">
      <park-info
        class="detail-box"
        v-if="detailShowPark"
        title="园区详情"
        :info="detailParkInfo"
        @onClosePark="onClosePark"
      ></park-info>
    </transition>
    <!-- 园区详情 -->

    <!-- 用地详情 -->
    <transition name="el-zoom-in-center">
      <land-detail
        class="detail-box"
        v-if="landShow"
        title="招商信息"
        :info="landInfo"
        @onCloseLand="onCloseLand"
      ></land-detail>
    </transition>
    <!-- 用地详情 -->

    <!-- 用地需求 -->
    <transition name="el-zoom-in-top">
      <div class="need-dialog" v-show="isReleaseNeed">
        <need :mapView="mapView" @close-need="closeNeed"></need>
      </div>
    </transition>
    <!-- 用地需求 -->

    <!-- 图例 -->
    <div class="map-tl">
      <div class="map-tl-title">图例</div>
      <div class="map-tl-li">
        <div class="map-tl-li-img">
          <img src="../../assets/images/common/tl1.png" alt="" />
        </div>
        <div class="map-tl-li-span">国家级开发区</div>
      </div>
      <div class="map-tl-li">
        <div class="map-tl-li-img">
          <img src="../../assets/images/common/tl2.png" alt="" />
        </div>
        <div class="map-tl-li-span">省级开发区</div>
      </div>
    </div>
    <!-- 图例 -->
  </div>
</template>
<script>
import Layer from "@/components/currency/layer";
import Tools from "@/components/currency/tools";
import ParkCardBox from "@/components/currency/parkCardBox";
import LandCardBox from "@/components/currency/cardBox";
import Need from "@/components/currency/need";
import ParkInfo from "./components/parkInfo";
import LandDetail from "./components/landDetail";

import { dictionaries, getXzqhList } from "@/api/common";
import {
  getParkPage,
  getlandList,
  landList,
  getLandInfo,
} from "@/api/setting/investment";

export default {
  name: "need-land",

  components: {
    Layer,
    Tools,
    LandCardBox,
    ParkCardBox,
    ParkInfo,
    LandDetail,
    Need,
  },
  data() {
    return {
      position: [101.41223328906251, 24.851597124999998],
      height: document.body.clientHeight - 190 + "px",
      mapView: undefined,
      xzqhList: [],
      configList: mapConfig.configList,
      regionValue: [],
      searchValue: null,
      countyValue: "", //行政区划
      type: 1, //查询类型
      //园区查询
      form: {
        current: 1,
        size: 4,
        total: 0,
      },
      //记录用地画范围id
      landMap: [],
      //用地查询
      landForm: {
        current: 1,
        size: 10,
        total: 0,
      },
      loading: false, //加载
      packList: [], //园区数组
      landList: [], //用地数组
      isLandBtottom: false, //用地是否到底
      isParkBtottom: false, //园区是否到底
      isExtranet: true,
      frist: true, //用地是否第一次加载
      fristPark: true, //园区是否第一次加载
      detailShowPark: false, //是否显示园区弹框
      detailParkInfo: {}, //园区详情数据
      investmentInfo: {}, //招商信息
      landShow: false,
      landInfo: {},
      isReleaseNeed: false, //是否显示发布需求
      checkNodeData: [], //已勾选图层数据
      tdytList: [],
      landSearch: {
        areaMin: null,
        areaMax: null,
        type: "",
      },
      typeStatus: "", //地块类型
      isEnd: 0,
      layerArr: layerConfig.parkDistributionLayer.layerIndex, //园区分布查询layerIndex
      layerIndex: 0, //园区分布查询起始位置
      area: [30, 60],
    };
  },
  watch: {
    type: function (val) {
      if (val == 1 && (this.searchValue || this.countyValue)) {
        this.getParkTable();
      }
      if (val == 2 && (this.searchValue || this.countyValue)) {
        //this.frist = true;
        this.getLands();
      }
    },
    countyValue: function (val) {
      if (val) {
        if (this.type == 1) {
          this.getParkTable();
        }
        if (this.type == 2) {
          this.getLands();
        }
      } else {
        this.landList = [];
        this.packList = [];
      }
    },
  },
  mounted() {
    this.getXzqh();
    this.getField("TDYT", "tdytList");
    this.$nextTick(() => {
      this.initMap();
      this.regionValue = ["53"];
      this.changeRegion(this.regionValue);
    });
  },
  created() {
    window.goUrl = this.goUrl;
  },
  methods: {
    //初始化地图
    initMap() {
      this.mapView = this.$refs.tzMap.tzApi;
      this.mapView.addSingleClickCallBack((arg1, xy) => {
        //let isLoaction = false;
        //this.mapAttribute(arg1, xy);

        this.isEnd = 0;
        this.layerIndex = 0;
        this.mapAttribute(arg1, xy);
        // 判断是否展示地块详情弹框
        if (arg1.values_.layerData) {
          this.showLandDetailPopup(xy, arg1.values_.layerData);
        }
      });
    },

    //查询地图属性
    mapAttribute(arg1, xy) {
      //有值后将不再查询
      let list = this.checkNodeData[this.isEnd].layerConfig;
      let url = this.findData(list, "url");
      console.log("url", url);

      let layerIndex = 0;
      if (url == layerConfig.parkDistributionLayer.url) {
        if (this.layerIndex < this.layerArr.length) {
          layerIndex = this.layerArr[this.layerIndex];
          this.layerIndex++;
        }
      }
      let geometry1 = xy;
      let geometryType = "esriGeometryPoint";
      this.searchMap(arg1, xy, url, layerIndex, geometry1, geometryType);
    },
    /**
     * 查询地图方法
     * url:查询服务地址  layerIndex：图层idnex  geometry1：坐标  geometryType：类型
     * */
    searchMap(arg1, xy, url, layerIndex, geometry1, geometryType) {
      this.mapView.queryArcGISRestByGeometry(
        url,
        layerIndex,
        geometry1,
        geometryType,
        async (res) => {
          if (
            res.features.length &&
            res.features[0].attributes &&
            res.features[0].geometry
          ) {
            let { attributes, geometry } = res.features[0],
              info;
            let parkInfoOne = {};
            if (attributes["开发区代码"] || attributes["产业园代码"]) {
              let code = attributes["开发区代码"] || attributes["产业园代码"];
              let { data: response } = await getParkPage({
                parkCode: code,
              });
              if (response.data.records && response.data.records.length) {
                parkInfoOne = response.data.records[0];
                this.searchValue = response.data.records[0].name;
                this.form.total = response.data.total;
                this.form.current = 1;
                this.type = 1;
                let packList = response.data.records;
                packList.forEach((item) => {
                  this.$set(item, "isAtive", true);
                  if (item.pronounceImages) {
                    let imgUrl =
                      item.pronounceImages.length > 0
                        ? systemConfig.imgServer +
                          systemConfig.imgApi +
                          item.pronounceImages[0].filePath
                        : null;
                    this.$set(item, "imgUrl", imgUrl);
                  }
                  if (item.pronounceVideos && item.pronounceVideos.length) {
                    item.pronounceVideos.forEach((itemFile) => {
                      this.$set(
                        itemFile,
                        "thumbnailSrc",
                        systemConfig.imgServer +
                          systemConfig.imgApi +
                          itemFile.thumbnail
                      );
                    });
                  }
                  if (item.pronounceImages && item.pronounceImages.length) {
                    item.pronounceImages.forEach((itemFile) => {
                      this.$set(
                        itemFile,
                        "url",
                        systemConfig.imgServer +
                          systemConfig.imgApi +
                          itemFile.filePath
                      );
                    });
                  }
                });
                this.packList = packList;
                this.detailParkInfo = packList[0];
                this.colseAll();
                this.mapView.removeVectorFeatureById("kfq_layer");
              }
            }
            this.mapView.removePopup("popup_detail");
            //属性内容
            let content = Object.keys(attributes).map((key) => {
              return { key: key, value: attributes[key] };
            });
            //拼接html字符
            let str = "";
            content.forEach((item) => {
              str =
                str +
                `<div class="popup-span">
                    ${item.key}：${item.value}
                    </div>`;
            });
            //按钮  detailBtnPark(${parkInfoOne},${true},${0})
            let btnHtml = parkInfoOne.id
              ? `<div class="popup-box-btn" onclick="goUrl(${1})" >查看详情</div>`
              : "";
            //躺框展示内容
            let contentstr = `<div class="popup-box">
                                      <div class="popup-box-title">图层属性</div>
                                      <div class="popup-box-content">${str}</div>
                                      ${btnHtml}
                                    </div>`;
            this.mapView.addPopup(contentstr, geometry1, "popup_detail", {
              //箭头出现位置
              positioning: "center-auto",
            });
            this.layerIndex = 0;
          } else {
            //layer为1时，要查两次同样的服务
            if (layerIndex == 0 || layerIndex == 3) {
              this.isEnd++;
            }

            if (this.isEnd < this.checkNodeData.length) {
              this.mapAttribute(arg1, xy);
            } else {
              // this.$message.error("当前点击位置无图层属性");
            }
          }
        }
      );
    },

    //
    getField(field, identification) {
      dictionaries(field).then((res) => {
        this[identification] = res.data.data;
      });
    },
    //定位到详情
    goUrl: function (val) {
      if (val == 1) {
        this.detailBtnPark(this.packList[0], true, 0);
      } else {
        this.landShow = true;
      }
    },
    findData(list, filed) {
      let index = list.findIndex((item) => item.filed == filed);
      let value = index >= 0 ? list[index].value : "";
      return value;
    },
    //图层已勾选数据
    callBackCheckNode(list) {
      this.checkNodeData = list;
    },

    clearFrom() {
      this.searchValue = "";
      this.landList = [];
      this.packList = [];
    },
    searchFrom() {
      if (this.searchValue == "") {
        this.landList = [];
        this.packList = [];
      } else {
        this.form.current = 1;
        if (this.type == 1) {
          this.getParkTable();
        } else {
          this.getLands();
        }
      }
    },

    //获取行政区划
    getXzqh() {
      getXzqhList().then((res) => {
        if (res.data.success) {
          this.xzqhList = res.data.data;
        }
      });
    },

    //根据行政区划
    changeRegion(arr) {
      if (arr.length) {
        this.countyValue = arr[arr.length - 1];
        this.mapView.removeVectorFeatureById("ssq");
        let len = arr.length;
        let val = arr[len - 1];
        if (arr.length) {
          // 通过判断 arr 数组的的内容 选择查询不同的的行政区数据： 0 地州市 1县级  3 省级
          let index = null;
          if (len == 1) {
            index = 3;
          } else if (len == 2) {
            index = 0;
          } else if (len == 3) {
            index = 1;
          }
          this.mapView.queryArcGISRestByAttribute(
            layerConfig.SSQ_Layer,
            index,
            `XZQDM like '${arr[arr.length - 1]}%'`,
            (res) => {
              if (res.features.length && res.features[0].geometry) {
                let zb = res.features[0].geometry.rings;
                this.mapView.addVectorMultiPolygon(
                  [zb],
                  res.features[0].attributes["sname"],
                  { id: "ssq" },
                  "#1d9300",
                  "rgba(0,0,0,0)",
                  "#1d9300",
                  "#ffffff",
                  undefined,
                  undefined,
                  3
                );
                let extent = this.mapView.getPolygonExtent(zb);
                this.mapView.zoomToExtent(
                  extent[0],
                  extent[1],
                  extent[2],
                  extent[3]
                ); //居中地图范围
              }
            }
          );
        }
        //this.getInfo(val);
        //this.getStatisticalData(val);
      } else {
        this.countyValue = "";
      }
    },

    //切换页码
    handleCurrentChange(val) {
      this.form.current = val;
      if (this.type == 1) {
        this.getParkTable();
      } else {
        this.getLands();
      }
    },

    //切换页条数
    handleSizeChange(val) {
      this.form.size = val;
      this.getParkTable();
    },

    /**
     * val 有值为条件查询
     */
    getParkTable() {
      this.loading = true;
      let params = Object.assign(this.form, {
        name: this.searchValue,
        county: this.countyValue,
      });
      getParkPage(params).then((res) => {
        if (res.data.success) {
          this.form.total = res.data.data.total;
          let list = res.data.data.records;
          //清除用地图斑
          if (this.landMap.length) {
            this.landMap.forEach((item) => {
              this.mapView.removeVectorFeatureById(item);
            });
          }
          this.landMap = [];
          this.fristPark = false;
          if (!list.length) {
            this.isParkBtottom = true;
          }
          list.forEach((item) => {
            this.$set(item, "isAtive", false);
            if (item.pronounceImages) {
              let imgUrl =
                item.pronounceImages.length > 0
                  ? systemConfig.imgServer +
                    systemConfig.imgApi +
                    item.pronounceImages[0].filePath
                  : null;
              this.$set(item, "imgUrl", imgUrl);
            }
            if (item.pronounceVideos && item.pronounceVideos.length) {
              item.pronounceVideos.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "thumbnailSrc",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.thumbnail
                );
              });
            }
            if (item.pronounceImages && item.pronounceImages.length) {
              item.pronounceImages.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "url",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.filePath
                );
              });
            }
          });
          this.packList = list;
          this.loading = false;
        }
      });
    },

    async getLands(otherParam) {
      this.loading = true;
      let params = Object.assign(
        this.form,
        {
          name: this.searchValue,
          county: this.countyValue,
          type: this.typeStatus,
        },
        otherParam
      );
      let { data: res } = await landList(params);
      if (res.success) {
        let list = res.data.records;
        this.form.total = res.data.total;
        //清除园区图斑
        this.mapView.removeVectorFeatureById("kfq_layer");
        list.forEach((item) => {
          this.$set(item, "isAtive", false);
          if (item.pronounceImages) {
            let imgUrl =
              item.pronounceImages.length > 0
                ? systemConfig.imgServer +
                  systemConfig.imgApi +
                  item.pronounceImages[0].filePath
                : null;
            this.$set(item, "imgUrl", imgUrl);
            item.pronounceImages = item.pronounceImages
              ? item.pronounceImages
              : [];
            if (item.pronounceImages.length) {
              item.pronounceImages.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "url",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.filePath
                );
              });
            }
            if (item.pronounceVideos && item.pronounceVideos.length) {
              item.pronounceVideos.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "thumbnailSrc",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.thumbnail
                );
              });
            }
            if (item.pronounceApproval && item.pronounceApproval.length) {
              item.pronounceApproval.forEach((itemFile) => {
                if (itemFile.suffix == "mp4") {
                  this.$set(
                    itemFile,
                    "thumbnailSrc",
                    systemConfig.imgServer +
                      systemConfig.imgApi +
                      itemFile.thumbnail
                  );
                }
                if (
                  itemFile.suffix == "png" ||
                  itemFile.suffix == "jpg" ||
                  itemFile.suffix == "pdf" ||
                  itemFile.suffix == "docx" ||
                  itemFile.suffix == "doc" ||
                  itemFile.suffix == "xlsx" ||
                  itemFile.suffix == "xls"
                ) {
                  this.$set(
                    itemFile,
                    "url",
                    systemConfig.imgServer +
                      systemConfig.imgApi +
                      itemFile.filePath
                  );
                }
              });
            }
          }
        });

        this.landList = list;
        this.loading = false;
      }
    },
    //出现用地的信息弹框
    showLandDetailPopup(center, data) {
      this.mapView.removePopup("popup_detail");
      let contentstr = `<div class="popup-box">
                                <div class="popup-box-title">基本信息</div>
                                <div class="popup-box-content">
                                  <div class="popup-span">地块类型：${
                                    data.typeName
                                  }</div>
                                  <div class="popup-span">土地坐落：${
                                    data.location
                                  }</div>
                                  <div class="popup-span">宗地编号：${
                                    data.code
                                  }</div>
                                  <div class="popup-span">土地等级：${
                                    data.typeName
                                  }</div>
                                  <div class="popup-span">用地面积：${
                                    data.area
                                  }公顷</div>
                                  <div class="popup-span">出让年限：${
                                    data.transferDate
                                  }年</div>
                                  <div class="popup-span">用地状态：${
                                    data.statusName
                                  }</div>
                                  <div class="popup-span">行政区划：${
                                    data.countyName
                                  }</div>
                                </div>
                               <div class="popup-box-btn" onclick="goUrl(${2})" >查看详情</div
                              </div>`;
      this.mapView.addPopup(contentstr, center, "popup_detail", {
        //箭头出现位置
        positioning: "center-auto",
      });
    },
    //查询用地详情
    getLandDetail(id) {
      getLandInfo(id)
        .then((res) => {
          if (res.data.success) {
            let data = res.data.data;
            if (data.pronouncePolygons && data.pronouncePolygons.fileInfo) {
              this.onLandLocation(data.pronouncePolygons.shapeInfo, data);
              let center = this.mapView.getMultiPolygonCenter(
                data.pronouncePolygons.shapeInfo[0].geom.coordinates
              );
              this.showLandDetailPopup(center, data);
            }
          }
        })
        .finally(() => {});
    },

    //用地定位
    onLandLocation(arr, data) {
      if (this.landMap.length) {
        this.landMap.forEach((item) => {
          this.mapView.removeVectorFeatureById(item);
        });
      }
      this.landMap = [];
      let len = arr.length;
      let l = 0;
      arr.forEach((item, index) => {
        let str = "landId" + index;
        this.mapView.addVectorMultiPolygon(
          item.geom.coordinates,
          data.name,
          { id: str, layerData: data },
          "#0a8708",
          "rgba(0,0,0,0)",
          "#0a8708",
          "#ffffff",
          undefined,
          undefined,
          3
        );
        if (index == 0) {
          let extent = this.mapView.getPolygonExtent(item.geom.coordinates[0]);
          this.mapView.zoomToExtent(extent[0], extent[1], extent[2], extent[3]); //居中地图范围
        }
        l = l + 1;
        //记录id
        this.landMap.push(str);
      });
    },

    //查询园区 园区定位
    parkData(parkCodeActual) {
      this.mapView.queryArcGISRestByAttribute(
        layerConfig.parkDistributionLayer.url,
        this.layerArr[this.layerIndex],
        `产业园代码 = '${parkCodeActual}'`,
        (res) => {
          if (res.features && res.features.length) {
            let { geometry, attributes } = res.features[0];
            if (geometry) {
              let zb = geometry.rings;
              //居中地图范围
              let extent = this.mapView.getPolygonExtent(zb);
              this.mapView.zoomToExtent(
                extent[0],
                extent[1],
                extent[2],
                extent[3]
              );
              this.mapView.addVectorMultiPolygon(
                [geometry.rings],
                attributes["开发区名称"] || attributes["产业园名称"],
                { id: "kfq_layer" },
                "#04ebf0",
                "rgba(0,0,0,0)",
                "#ffffff",
                "#04ebf0",
                undefined,
                undefined,
                4
              );
            }
          } else {
            if (this.layerIndex < this.layerArr.length) {
              this.layerIndex++;
              this.parkData(parkCodeActual);
            } else {
              console.log("没有找到对应园区位置");
            }
          }
        }
      );
    },
    //关闭所有自定义组件弹窗
    colseAll() {
      this.detailShowPark = false;
      this.landShow = false;
    },

    /**
     * info:园区信息 ， val:是否选中 ,nowIndex:当前操作下标
     */
    detailBtnPark(info, val, nowIndex) {
      this.detailShowPark = val;
      this.detailParkInfo = info;

      //关闭弹窗
      this.landShow = false;
      if (val) {
        this.mapView.removeVectorFeatureById("kfq_layer");
        this.parkData(info.parkCodeActual);
        //this.onParkLocation(info.parkCodeActual);
      }
      this.packList.forEach((item, index) => {
        if (index == nowIndex) {
          item.isAtive = val;
        } else {
          item.isAtive = false;
        }
      });
    },
    /**
     * info:地块信息 ， val:是否选中,nowIndex:当前操作下标
     */
    detailBtnLand(info, val, nowIndex) {
      //this.landShow = val;
      this.landInfo = info;

      //关闭弹窗
      this.detailShowPark = false;

      if (val) {
        this.getLandDetail(info.id);
      }
      this.landList.forEach((item, index) => {
        if (index == nowIndex) {
          item.isAtive = val;
        } else {
          item.isAtive = false;
        }
      });
    },
    //关闭园区详情
    onClosePark() {
      this.detailShowPark = false;
    },
    //关闭用地详情
    onCloseLand() {
      this.landShow = false;
    },

    //发布需求
    releaseNeed() {
      this.isReleaseNeed = !this.isReleaseNeed;
    },

    //关闭需求
    closeNeed() {
      this.isReleaseNeed = false;
    },
    areaSliderChange(val) {
      this.landSearch.areaMax = val[1];
      this.landSearch.areaMix = val[0];
    },
    // 地块条件查询
    landQuery() {
      if (this.landSearch.type || this.landSearch.areaMax) {
        if (this.landSearch.areaMin > this.landSearch.areaMax) {
          this.$message.error("最小面积 不能大于 最大面积！！");
        } else {
          let data = {
            areaMix: this.landSearch.areaMin,
            areaMax: this.landSearch.areaMax,
            type: this.landSearch.type,
          };
          this.getLands(data);
        }
      } else {
      }
    },
    resetLandQuery() {
      if (this.form.type != undefined) {
        this.landSearch.areaMin = null;
        this.landSearch.areaMax = null;
        this.landSearch.type = "";
        delete this.form.areaMix;
        delete this.form.areaMax;
        delete this.form.type;
        this.getLands();
      }
    },
    // 快捷查询 地块  园区
    shortcutQuery(val) {
      if (this.typeStatus == val) {
        //相同则取消选择
        this.typeStatus = "";
      } else {
        this.typeStatus = val;
      }
      this.getLands();
    },
  },
  updated() {
    this.$nextTick(() => {
      // 设置滚动条默认到底
      window.scrollTo(0, document.body.scrollHeight);
    });
  },
};
</script>
<style>
.land-area-number {
  width: 100px;
  margin: 0 5px;
}

.land-area-number .el-input-number__decrease,
.land-area-number .el-input-number__increase {
  width: 12px !important;
  font-size: 12px !important;
}

.land-area-number .el-input__inner {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.landQueryCondition .el-form-item--mini.el-form-item,
.landQueryCondition .el-form-item--small.el-form-item {
  margin-bottom: 11px;
}
</style>
<style scoped>
#need-land {
  display: flex;
  flex-direction: column;
  width: 100%;
  /*height: 900px;*/
  position: relative;
}

::v-deep .popup-box {
  line-height: 26px;
  max-width: 500px;
}

::v-deep .popup-box-content {
  padding: 0 10px;
  max-height: 300px;
  overflow: auto;
}

::v-deep .popup-box-btn {
  margin: 10px auto;
  width: 100px;
  height: 30px;
  line-height: 30px;
  background: #157cf3;
  color: #fff;
  border-radius: 4px;
  border-radius: 4px;
  text-align: center;
}

::v-deep .popup-box-title {
  color: #fff;
  font-size: 0.85rem;
  padding: 5px 10px;
  font-weight: bold;
  background: #0657b4;
}

::v-deep .ol-popup.hasclosebox .ol-popup-content {
  margin-right: 0;
}

::v-deep .ol-popup .ol-popup-content {
  padding: 0;
}

::v-deep .ol-popup .closeBox {
  position: absolute;
  margin: 0;
  right: 3px;
  top: 8px;
}

.administrative-region {
  position: absolute;
  top: 20px;
  right: 375px;
}

.layer {
  position: absolute;
  top: 20px;
  right: 285px;
}

.tool {
  position: absolute;
  top: 20px;
  right: 195px;
}

.map-tl {
  position: absolute;
  bottom: 10px;
  right: 100px;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0 0 10px #d3d2d2;
}

.map-tl-title {
  text-align: center;
  padding: 5px 0;
  font-size: 0.85rem;
}

.map-tl-li {
  display: flex;
  font-size: 0.75rem;
  padding: 5px 10px;
}

.map-tl-li-span {
  padding-left: 5px;
  color: #787676;
}

.need-dialog {
  position: absolute;
  top: 60px;
  right: 20px;
}

.land-need-box {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #fff;
  border: 1px solid #dcdfe6;
  line-height: 26px;
  border-radius: 4px;
  height: 26px;
  padding: 0 10px;
  font-size: 0.8rem;
}

.land-need-box-span1 {
  color: #787676;
}

.land-need-box-span2 {
  color: #0657b4;
  cursor: pointer;
}

.detail-box {
  position: absolute;
  z-index: 30;
  width: 26%;
  left: calc(26% + 164px);
  top: 80px;
  bottom: 10px;
}

.search-box {
  width: 380px;
  position: absolute;
  top: 20px;
  left: 10px;
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;
}

.search-box-input {
  width: 100%;
  height: 28px;
}

.search-box-box {
  background: #fff;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  /* border-left: 1px solid #b1abab;
  border-right: 1px solid #b1abab;
  border-bottom: 1px solid #b1abab; */
}

.search-box-box-top {
  margin-top: 43px;
  width: 160px;
  height: 100px;
}

.search-box-box-top > img {
  width: 100%;
  height: 100%;
}

.search-box-box-center {
  font-size: 0.75rem;
  color: #787676;
}

.search-box-box-btn {
  /* margin-top: 20px; */
  width: 100px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 0.85rem;
  color: #fff;
  background: #2875e9;
  border-radius: 6px;
  cursor: pointer;
}

.search-box-list {
  border-radius: 6px 6px 0 0;
  overflow: hidden;
  margin-top: 20px;
}

.search-box-list-top {
  background: #fff;
  display: flex;
  height: 28px;
  line-height: 28px;
  border-radius: 8px 8px 0 0;
}

.search-box-list-top-li {
  width: 50%;
  text-align: center;
  font-size: 0.85rem;
}

.active-li {
  color: #fff;
  background: #157cf3;
}

.dft-li {
  color: #787676;
  border: 1px solid #157cf3;
}

.search-box-list-table {
  background: #fff;
  height: calc(100% - 78px);
  min-height: 439px;
  overflow: auto;
  width: calc(100% - 2px);
  border-left: 1px solid #b1abab;
  border-right: 1px solid #b1abab;
}

.search-box-list-page {
  background: #fff;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 2px);
  border-left: 1px solid #b1abab;
  border-right: 1px solid #b1abab;
  border-bottom: 1px solid #b1abab;
}

::v-deep .el-pagination .btn-prev {
  margin: 0 10px;
  padding-right: 8px;
  /* border: 1px solid rgb(194, 192, 192); */
}

::v-deep .search-box-list-page .el-pagination .btn-next {
  padding-left: 8px;
  margin: 0 10px;
  /* border: 1px solid rgb(194, 192, 192); */
}

::v-deep .el-pager li {
  padding: 0;
  margin: 0 4px;
  min-width: 18.5px;
}

::v-deep .el-pagination button,
.el-pagination span:not {
  font-size: 0.75rem;
  height: 26px;
  line-height: 26px;
}

.table-land {
  position: relative;
}

.landQueryCondition {
  margin: 10px 10px;
  border-bottom: 1px solid #e7e7e7;
}

.landQueryCondition .queryButtonItem {
  display: flex;
  justify-content: flex-end;
}

.landQueryCondition .queryButtonItem .queryButton {
  width: 60px;
}
.shortcut-query {
  position: absolute;
  left: 421px;
  top: 25px;
}

.need-area {
  width: 280px;
  display: flex;
  align-items: center;
}

.need-area-slider {
  display: inline-block;
  width: 100px;
  margin: 0 5px;
}

.need-area-input {
  width: 50px;
  display: inline-block;
  padding: 0 8px;
}
</style>
